import type Mithril from 'mithril';

/**
 * Mithril 2 does not completely rerender the page if a route change leads to the same route
 * (or the same component handling a different route). This util calls m.route.set, forcing a reonit.
 *
 * @see https://mithril.js.org/route.html#key-parameter
 */
//route: string：表示要设置的路由路径，是一个字符串类型。
//params = null：表示路由的参数，默认值为 null。这个参数用于传递额外的路由参数，比如动态路由中的参数。
//options: Mithril.RouteOptions = {}：表示路由选项，是一个带有默认值的对象。Mithril.RouteOptions 是一个类型定义，用于指定路由的选项配置。
export default function setRouteWithForcedRefresh(route: string, params = null, options: Mithril.RouteOptions = {}) {
  //创建一个新的对象 newOptions，使用对象扩展运算符 ... 将原始的 options 对象进行浅拷贝，保留原有的属性和值。
  const newOptions = { ...options };
  //在 newOptions 对象中添加一个 state 属性，如果 newOptions 对象中已经有了 state 属性，则保留原有的值；否则，设置为空对象 {}。
  newOptions.state = newOptions.state || {};
  //在 newOptions.state 对象中添加一个 key 属性，并赋值为当前的时间戳（通过 Date.now() 函数生成），用于强制刷新路由。
  newOptions.state.key = Date.now();
//调用 m.route.set 方法，设置新的路由。m.route 是 Mithril.js 框架提供的路由功能，.set 是其中的一个方法，用于设置路由。通过传入 route（要设置的路由路径）、params（路由参数）和 newOptions（路由选项），实现路由的设置。
  m.route.set(route, params, newOptions);
}
